import http, { url } from "../../http";

const API_URL = "measurement_incidence_Disease";

class medicionPrevalenciaAPI {
  async save(resource) {
    const response = await http(`${API_URL}/save`, "POST", resource);
    return response;
  }

  async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST');
    return response;
  }

  async show(id) {
    const response = await http(`${API_URL}/show/${id}`);
    return response;
  }

/*   async getExcel(companyId) {
    return url(`${API_URL}/excel_report/${companyId}`);
  } */

  async get(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST');
    return response;
  }

  async report(id) {
    const response = await http(`${API_URL}/report/${id}`, "POST");
    return response;
  }

  async getExcel(companyId) {
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.token) {
      return url(
        `${API_URL}/excel_report/${companyId}?&access_token=${user.token}`
      );
    }

  }

  async getShow(id) {
    const response = await http(`${API_URL}/${id}`);
    return response;
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, "PUT", resource);
    return response;
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, "DELETE");
    return response;
  }
}

export default new medicionPrevalenciaAPI();
